<template>
  <vz-direction-calendar
    direction-to
    :dates="destinationDates"
    :disabled="disabled"
    @change-day="onChangeDestinationDay"
  />
  <slot />
  <vz-direction-calendar-time
    v-if="destinationDate && orderStore.orderForm.directions.destination.direction === 'address'"
    direction-to
    :date="destinationDate"
    :disabled="disabled"
    :has-waiting="!hideWaiting"
    @select-time="onSelectDestinationTime"
  >
  </vz-direction-calendar-time>
  <vz-direction-calendar-terminal-time
    v-else
    direction-to
    :date="destinationDate"
    :disabled="disabled"
    @select-time="onSelectDestinationTime"
  />
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import {TimetableDate} from '~/types/types';
import VzDirectionCalendar from '~/components/personal/order/direction/calendar/vz-direction-calendar.vue';
import VzDirectionCalendarTime from '~/components/personal/order/direction/calendar/vz-direction-calendar-time.vue';
import VzDirectionCalendarTerminalTime from '~/components/personal/order/direction/calendar/vz-direction-calendar-terminal-time.vue';
import {deepCopyObject} from '~/common/functions';
import {daysOfWeeks} from '~/common/date';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  hideWaiting: {
    type: Boolean,
    default: false
  }
})

const orderStore = useOrderStore()

const destinationDates = computed((): TimetableDate[] | undefined => {
  const group = deepCopyObject(orderStore.timetable?.destination?.[orderStore.splitIndex] || orderStore.timetable?.destination?.[0])

  if (group?.dates && orderStore.orderForm.isNetwork && orderStore.networkingAddress?.timetable) {
    group.dates.forEach((date: TimetableDate) => {
      if (!date.isDisabled) {
        const d = new Date(date.date)
        const day = daysOfWeeks[d.getDay()]?.eng
        if (day && Object.keys(orderStore.networkingAddress?.timetable || {}).includes(day)) {
          date.mark = true
        }
      }
    })
  }

  return group?.dates
})

const destinationDate = computed((): TimetableDate | undefined => {
  return orderStore.timetable?.destination?.[orderStore.splitIndex]?.dates.find(d => d.isDefault)
})

function onChangeDestinationDay(date: TimetableDate) {
  orderStore.orderForm.directions.destination.calendar.date = date.date
  orderStore.updateTimeTable()
}

function onSelectDestinationTime() {
  orderStore.getOrderPriceAction()
}
</script>

<style lang="scss">

</style>
